import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Overlay } from 'ol';
import { merge, Observable } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import { MappaService } from 'src/app/servizi/mappa/mappa.service';
import { NamSelectedObjectService } from 'src/app/servizi/nam/nam-object-selected.service';
import { NamService } from 'src/app/servizi/nam/nam.service';

@Component({
  selector: 'app-select-popup',
  templateUrl: './select-popup.component.html',
  styleUrls: ['./select-popup.component.scss'],
})
export class SelectPopupComponent implements OnInit {
  //@Input() mappa: MapComponent;

  namPopupContainer: HTMLElement;
  namPopupCloser: HTMLElement;

  namPopup: Overlay;

  selectedObjectBackground$: Observable<unknown>;

  constructor(
    public namService: NamService,
    private namSelectedObjectService: NamSelectedObjectService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private mapService: MappaService
  ) {
    this.selectedObjectBackground$ = merge(
      namSelectedObjectService.selectedObjectForEditGeometry$.pipe(map((s) => ({ ...s, background: 'bg-info' }))),
      namSelectedObjectService.selectedObjectToHighlight$.pipe(map((s) => ({ ...s, background: 'bg-warning' }))),
      namSelectedObjectService.deselectedObject$.pipe(map((s) => ({ ...s, background: 'none' })))
    ).pipe(shareReplay(1));
  }

  ngOnInit(): void {
    this.configureNam();
  }

  configureNam() {
    this.namPopupContainer = document.getElementById('namPopup');
    this.namPopupCloser = document.getElementById('namPopup-closer');

    this.namPopup = new Overlay({
      element: this.namPopupContainer,
      autoPan: {
        animation: {
          duration: 250,
        },
      },
    });
    this.namService.namPopup = this.namPopup;
  }

  closeNamPopup() {
    this.namService.closePopup();
    this.mapService.mappa.deleteOverlay(this.namPopup);
  }

  // selectFeature(feature: any) {
  //   console.log('FUFFI', feature);

  //   // //featureId is the same as the URN of an element
  //   // this.namSelectedObjectService.selectedObject = e;

  //   // //Update the urn in the url without changing the route.
  //   // //This does not trigger a reload.
  //   // this.router.navigate(
  //   //   [],
  //   //   {
  //   //     relativeTo: this.activatedRoute,
  //   //     queryParams: { urn: e.urn },
  //   //     queryParamsHandling: 'merge'
  //   //   });
  //   this.closeNamPopup();
  // }

  handleSelectRelatedObjectInfo(e: any) {
    this.namSelectedObjectService.selectedObjectForInfo = e;
    this.closeNamPopup();
  }

  handleSelectRelatedObjectToHighlight(e: any) {
    this.namSelectedObjectService.selectedObjectToHighlight = e;
    this.closeNamPopup();
  }

  handleSelectRelatedObjectEditGeometry(e: any) {
    this.namSelectedObjectService.selectedObjectForEditGeometry = e;
    this.closeNamPopup();
  }

  handleDeselectRelatedObjectGeometry(e: any) {
    this.namSelectedObjectService.deselectedObject = e;
  }
}
